/* eslint-disable */
// @ts-nocheck
import { Directive, ElementRef, forwardRef, HostListener, Renderer2 } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import * as Sentry from "@sentry/angular-ivy";

@Directive({
	selector: '[qeCustomInput]',
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => CustomInputDirective),
			multi: true,
		},
	],
})
export class CustomInputDirective implements ControlValueAccessor {

	// eslint-disable-next-line
	private innerValue!: any;
	public disabled: boolean = false;

	@HostListener('blur', ['$event'])
	public handleTouch (ev: UIEvent) {
		this.onTouched();
	}
	@HostListener('click', ['$event'])
	public handleTouchClick (ev: UIEvent) {
		this.onTouched();
	}
	@HostListener('epiValueChanged', ['$event'])
	public handleChange (ev: CustomEvent) {
		this.value = ev.detail;
	}

	public onChange: any = () => { };
	public onTouched: any = () => { };

	public get value (): any {
		return this.innerValue;
	}

	public set value (val: any) {
		// if (val !== this.innerValue) {
			this.innerValue = val;
			this.onChange(val);
		// }
	}

	constructor (
		private readonly el: ElementRef,
		private readonly renderer: Renderer2,
	) { }

	/** Handles the value being updated programatically */
	writeValue (value: any): void {
		try {
		this.renderer.setProperty(
			this.el.nativeElement,
			'value',
			value,
		);
		} catch (error) {
			Sentry.setContext("QuotaExceededError",{
				storageSession: window.sessionStorage
			})
		}
	}

	/** Handles the change of the control's value */
	registerOnChange (fn: any): void {
		this.onChange = fn
	}

	/** Handles the 'touched' state of the control */
	registerOnTouched (fn: any): void {
		this.onTouched = fn;
	}

	/** FIXME: this needs to se the disabled state on inputs and the dropdowns */
	setDisabledState (isDisabled: boolean): void {
		this.renderer.setAttribute(
			this.el.nativeElement,
			`disabled`,
			`${isDisabled}`,
		);
	}

}
